export function getPostWarningStorageKey(user) {
  const userId = user?.user_uuid || user?.sub || user?.id || user?.username || "anonymous";
  return `recettes_post_warning_seen:${userId}`;
}

export function hasSeenPostWarning(user) {
  return localStorage.getItem(getPostWarningStorageKey(user)) === "true";
}

export function markPostWarningSeen(user) {
  localStorage.setItem(getPostWarningStorageKey(user), "true");
}
